/**
 * The message the apply path stores when a worker takes the asking price
 * without writing anything. It is persisted verbatim in English, so rendering
 * `proposal.message` raw showed English to every Spanish and Portuguese reader.
 * The writer and this reader share the constant so a rewording on one side
 * cannot silently strand the other.
 */
export const ACCEPTED_ASKING_PRICE_MESSAGE = "Accepted asking price";

export type ProposalMessageView =
  | { kind: "acceptedAskingPrice" }
  | { kind: "text"; text: string };

/**
 * Decide what, if anything, to show for a proposal's message. Pure: the
 * component owns the `t()` call for the canned case.
 *
 * On a volunteer quest the canned line is dropped, not translated — the card
 * already says "Volunteered", and "accepted asking price" describes a price
 * that does not exist.
 */
export function proposalMessageView(
  message: string | null | undefined,
  opts: { isVolunteer: boolean },
): ProposalMessageView | null {
  const text = message?.trim();
  if (!text) return null;
  if (text === ACCEPTED_ASKING_PRICE_MESSAGE) {
    return opts.isVolunteer ? null : { kind: "acceptedAskingPrice" };
  }
  return { kind: "text", text };
}
